import React, { ReactElement } from 'react';
import { Body, Headline, Text } from '../../../components';
import Block from '../../block';
import GlobalTemplate from '../global';
import SupportNav from './partials/support-nav';

// The wrapper template for all pages on the /support route.
export default function SupportTemplate({ children }): ReactElement {
  return (
    <GlobalTemplate pageBgColor="white" navBgColor="purple-500">
      <Block
        className="bg-cover bg-bottom bg-no-repeat pt-16"
        style={{
          backgroundImage:
            "url('https://res.cloudinary.com/stark-lab/image/upload/v1761258422/marketing/headers/gradient-bg_yysn6k.webp')",
          marginTop: -65,
        }}
        bgColor="var(--color-base-purple-500)">
        <header className="relative mt-14">
          <div className="relative z-10 max-w-148">
            <Text level="mono" color="yellow" className="mb-4">
              Support
            </Text>

            <Headline level="hero" color="white">
              How can we help you?
            </Headline>

            <Body color="white" className="mt-6 mb-24 max-w-133">
              Get answers to all your Stark-related questions with <br />
              step-by-step guides from our Support center.
            </Body>
          </div>
        </header>
      </Block>

      <Block>
        <div className="support-main__wrapper flex max-[800px]:block">
          <SupportNav />

          <main
            className="support-main mt-20 w-full max-w-161.25 scroll-mt-40 max-[1200px]:w-auto max-[800px]:mt-4 md:scroll-mt-20"
            id="main">
            {children}
          </main>
        </div>
      </Block>
    </GlobalTemplate>
  );
}
